<template>
  <CmStateCard
    :isLoading="isLoading"
    :isError="isError"
    :isEmpty="!value || (value && !value.length)"
    class="cm-state-card--grouped-bar"
  >
    <CmGroupedBar
      mainKey="date"
      :labels="labels"
      :value="value"
    />
  </CmStateCard>
</template>

<script>
import { getPercent } from "@/utils/general";
import CmStateCard from '@/components/library/statistics/cards/CmStateCard.vue';
import CmGroupedBar from "@/components/library/statistics/elements/CmGroupedBar";
import { mapState } from "vuex";

export default {
  components: {
    CmStateCard,
    CmGroupedBar,
  },

  data() {
    return {
      labels: {
        sent: "Отправлено",
        delivered: "Доставлено",
        errors: "Ошибки",
      },
    };
  },

  computed: {
    ...mapState({
      isLoading: state => state.stat.loadings.details,
      isError: state => state.stat.errors.details,
    }),
    value() {
      return this.formData(this.$store.getters.getDetails);
    },
  },

  methods: {
    formData(arr) {
      return arr.map(i => {
        const { date, sent, errors, delivered } = i;

        return {
          date,
          sent,
          delivered,
          deliveredPercent: getPercent(sent, delivered),
          errors,
          errorsPercent: getPercent(sent, errors),
        };
      });
    },
  },
};
</script>
